export default __webpack_public_path__ + "static/media/link.4234090f.svg";